<template>
  <div class="newView">
    <div class="newTitle">新闻中心</div>
    <img src="http://video.naolamp.com/officialWeb/index/new_top.jpg"/>
    <div class="newList container">
      <div class="item container" v-for="item in dataLst" :key="item.id">
        <a :href="item.url" target="_blank">
          <div></div>
          <div class="itemImg" v-bind:style="{backgroundImage:'url(' + (item.thumbUrl || 'http://video.naolamp.com/bbs_front/1529041405718.jpg') + ')',
                  backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover'}">
          </div>
          <div class="content">
            <h2>
              {{item.title}}
            </h2>
            <div class="dateDiv">
              <div style="font-family: 'SourceHanSansCN-Normal';">{{ parseInt(item.updateTime)*1000 | formatDate }}&nbsp;&nbsp;|&nbsp;&nbsp;</div>
              <div style="font-family: 'SourceHanSansCN-Normal';">公司新闻</div>
            </div>
            <div class="digest">{{item.digest}}</div>
          </div>
        </a>
      </div>
    </div>
    <div class="newMore" v-show="MoreShow" @click="getRecordHis()">查看更多</div>
    <div class="LoadMore" v-show="!MoreShow"></div>
    <loading text='加载中...' duration='2s' v-if="isLoad"></loading>
  </div>
</template>

<script>
import loading from '../common/loading.vue'
export default {
  name: 'newsList',
  data () {
    return {
      msg: '新闻列表页',
      page: 0,
      pageSize: 5,
      totalPages: 10,
      MoreShow: false,
      dataLst: [{
        'id': 418,
        'mediaId': 'fieb0tM7eDlmR-KBfafQcNvNW6R4PyMvZCqHXFOY4Ao',
        'itemIndex': 0,
        'title': '一次《灯改》引发的爱情，女白领大众凌度蜡烛灯改车灯师记！',
        'digest': '爱情就是这么简单。',
        'content': null,
        'contentSourceUrl': '',
        'thumbMediaId': 'fieb0tM7eDlmR-KBfafQcLxyAonwoUNusycANlqzkNY',
        'url': 'http://mp.weixin.qq.com/s?__biz=MzI0Mjc5ODg0NQ==&mid=100000599&idx=1&sn=be8e3352822ebbf0070f32fdd27ef14a&chksm=69779ac55e0013d37b7947346a0fe805e200c724b00974f070b9afeb29fbe141773b77f51149#rd',
        'thumbUrl': 'http://video.naolamp.com/wxnews/CropImage8462547804292866316.CropImage',
        'author': '',
        'updateTime': '1531301999',
        'createTime': '1531277750',
        'canShow': 'N'
      }, {
        'id': 417,
        'mediaId': 'fieb0tM7eDlmR-KBfafQcNvNW6R4PyMvZCqHXFOY4Ao',
        'itemIndex': 0,
        'title': '一次《灯改》引发的爱情，女白领大众凌度蜡烛灯改车灯师记！',
        'digest': '爱情就是这么简单。',
        'content': null,
        'contentSourceUrl': '',
        'thumbMediaId': 'fieb0tM7eDlmR-KBfafQcLxyAonwoUNusycANlqzkNY',
        'url': 'http://mp.weixin.qq.com/s?__biz=MzI0Mjc5ODg0NQ==&mid=100000599&idx=1&sn=be8e3352822ebbf0070f32fdd27ef14a&chksm=69779ac55e0013d37b7947346a0fe805e200c724b00974f070b9afeb29fbe141773b77f51149#rd',
        'thumbUrl': 'http://video.naolamp.com/wxnews/CropImage8462547804292866316.CropImage',
        'author': '',
        'updateTime': '1531301999',
        'createTime': '1531277750',
        'canShow': 'N'
      }],
      isLoad: true,
      details: [{
        'cartId': 3,
        'num': 2,
        'productId': 120,
        'installType': 'store'
      }, {
        'cartId': 1,
        'num': 2,
        'productId': 9,
        'installType': 'store'
      }]
    }
  },
  computed: {
  },
  mounted: function (s) {
    this.getRecordHis()
    this.isLoad = false
  },
  methods: {
    testUrl: function () {
      let that = this
      that.page = that.page + 1
      that.axios.post('order/save', {
        userId: '402888c563f7211f0163f721b2d10000',
        addressId: 2,
        details: JSON.stringify(that.details)
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          console.log(response.data)
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    'getRecordHis': function () {
      let that = this
      that.page = that.page + 1
      that.axios.post('news/getList', {
        page: that.page,
        pageSize: that.pageSize
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          var res = response.data.value
          if (that.page === 1) {
            that.dataLst = res.dataLst
          } else {
            that.dataLst = that.dataLst.concat(res.dataLst)
          }
          if (res.dataLst.length >= that.pageSize) {
            that.MoreShow = true
          } else {
            that.MoreShow = false
          }
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  },
  filters: {
  },
  components: {
    loading
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.newView {
  background-color: #F0F0F0;
  padding-bottom: 70px;
}
.newView img {
  background-color: #FFFFFF;
  padding-top: 52px;
  width: 100%;
  margin-bottom: 50px;
}
.newTitle {
  position: absolute;
  width: 100%;
  min-width: 1200px;
  padding-top: 150px;
  color: white;
  font-size: 30px;
}
.newList {
  width: 1200px;
  margin: 0 auto;
}
.newList .item {
  margin-top: 20px;
  padding: 40px 160px 40px 75px;
  background-color: #FFFFFF;
  height: 220px;
}
.newList .item .itemImg{
  padding: 0;
  width: 420px;
  height: 220px;
  float: left;
  margin-right: 100px;
}
.newList .item .content {
  float: left;
  width: 440px;
}
.newList .item .content h2{
  font-weight: 600;
  text-align: left;
  line-height: 45px;
}
.newList .item .content .dateDiv {
  margin: 20px 0 30px 0;
  width: 420px;
  height: 21px;
}
.newList .item .content .dateDiv div{
  float: left;
  height: 21px;
  line-height: 21px;
}
.newList .item .content .dateDiv div:last-child{
  color: #06B570;
}
.newList .item .content .digest{
  text-align: left;
  font-family: "SourceHanSansCN-Normal";
}
.newMore {
  margin-top: 20px;
  color: #06B570;
  text-align: center;
  cursor: pointer;
}
.newMore:hover {
  opacity: .5;
}
</style>



// WEBPACK FOOTER //
// src/components/news/newList.vue